module.exports = __webpack_public_path__ + "images/stickers/warning.f8832dabce0aabd9a3b5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/warning.png
// module id = HeLc
// module chunks = 12